import { useState, useEffect } from 'react';
import { Activity, Target, Radar, ActivitySquare, MessageCircle, 
    Globe2, Globe, Users, Users2, Bot, Trophy,
    Settings,
    Eye,
    LockOpen,
    LockKeyholeOpen,
    ClipboardClockIcon,
    History,
    File, 
} from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// states_g
import { openSidebar, closeSidebar } from './../redux/sidebarSlice';
import { setmodalgeneral } from './../redux/modalsSlice'

import { icons } from '../utilities/icn';
import { images } from '../utilities/img';

// components
import Sos from './sos';


const Sidebar = () => {

    const modalgeneral = useSelector((state) => state.modalgeneral.value)
    const showsidebar = useSelector((state) => state.showsidebar.value)
    const pathlocation = useLocation()
    const dispatch = useDispatch()

    const windowscrollvalue = window.scrollY
    const [windowWidth, setWindowWidth] = useState(window.innerWidth)

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
            // console.log(window.innerWidth)
        };

        const handleScroll = () => {
            // console.log(window.scrollY)
            if(windowWidth < 1100) {
                dispatch(closeSidebar())
            }
        }

        window.addEventListener('resize', handleResize);

        window.addEventListener('scroll', handleScroll);

        // Cleanup: Remove the event listener when the component is unmounted
        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('scroll', handleScroll)
        };
    }, []);

    useEffect(() => {
        if(windowWidth < 1100) {
            dispatch(closeSidebar())
        } else if (windowWidth > 1100) {
            dispatch(openSidebar())
        }
    }, [windowWidth])

    const handleShowsidebar = () => { 
        if(windowWidth < 900) {
            if(showsidebar) {
                dispatch(closeSidebar())
            } else {
                dispatch(openSidebar())
            }
        }
    }

    // const setAlltoNull = () => {
    //     setmodalgeneral(null)
    // }



    return ( 

        <div className="">

            <Sos windowWidth={windowWidth} />

            {pathlocation.pathname !== '/auth' && pathlocation.pathname !== '/ring' && pathlocation.pathname !== '/account-data-deletion' && pathlocation.pathname !== '/privacy-policy' ? 
                <div className={`sidebar ${showsidebar ? 'active' : ''}`}>
                    {/* <div className="sidebar-top flex justify-space-between align-center">
                        <div className="sidebar-logo-cont flex row align-center">
                            <div className="tech-logo">
                                <img src={images.general.ev_logo_single} alt="" />
                            </div>
                            <div className="">
                                <h2 className='funnel_f'>EVALYS</h2>
                                <p className='inter'>Follow Smart Money</p>
                            </div>
                        </div>

                        {windowWidth < 1100 ? 
                            <div className="sidebar-close-icon flex justify-center align-center cursor-pointer" onClick={() => dispatch(closeSidebar())}>
                                <img src={icons.header.close} alt="" />
                            </div>
                        : null}

                    </div> */}

                    <div className="sidebar-links-cont">

                        {/* <h3 className="hn_medium"></h3> */}
                        
                        <Link to='' className={`sidebar-link-item flex row align-center cursor-pointer ${pathlocation.pathname === '/' ? 'active' : ''}`} onClick={handleShowsidebar}>
                            <div className="sidebar-icon-box">
                                <Eye className={`${pathlocation.pathname === '/' ? 'ev-p1' : 'd-white_c'}`} size={windowWidth < 500 ? 15 : 20} />
                            </div>
                            <p className="hn_medium">Watchlist</p>
                        </Link>

                        <Link to='open-positions' className={`sidebar-link-item flex row align-center cursor-pointer ${pathlocation.pathname === '/open-positions' ? 'active' : ''}`} onClick={handleShowsidebar}>
                            <div className="sidebar-icon-box">
                                <LockKeyholeOpen className={`${pathlocation.pathname === '/open-positions' ? 'ev-p1' : 'd-white_c'}`} size={windowWidth < 500 ? 15 : 20} />
                            </div>
                            <p className="hn_medium">Open Position</p>
                        </Link>

                        <Link to='history' className={`sidebar-link-item flex row align-center cursor-pointer ${pathlocation.pathname === '/history' ? 'active' : ''}`} onClick={handleShowsidebar}>
                            <div className="sidebar-icon-box">
                                <History className={`${pathlocation.pathname === '/history' ? 'ev-p1' : 'd-white_c'}`} size={windowWidth < 500 ? 15 : 20} />
                            </div>
                            <p className="hn_medium">History</p>
                        </Link>
                        
                        <Link to='settings' className={`sidebar-link-item flex row align-center cursor-pointer ${pathlocation.pathname === '/settings' ? 'active' : ''}`} onClick={handleShowsidebar}>
                            <div className="sidebar-icon-box">
                                <Settings className={`${pathlocation.pathname === '/settings' ? 'ev-p1' : 'd-white_c'}`} size={windowWidth < 500 ? 15 : 20} />
                            </div>
                            <p className="hn_medium">Settings</p>
                        </Link>

                        <Link to='help-docs' className={`sidebar-link-item flex row align-center cursor-pointer ${pathlocation.pathname === '/help-docs' ? 'active' : ''}`} onClick={handleShowsidebar}>
                            <div className="sidebar-icon-box">
                                <File className={`${pathlocation.pathname === '/help-docs' ? 'ev-p1' : 'd-white_c'}`} size={windowWidth < 500 ? 15 : 20} />
                            </div>
                            <p className="hn_medium">Help / Docs</p>
                        </Link>

                        


                    </div>


                </div> 
            : null}

        </div>
    );
}
 
export default Sidebar;